// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.swal-actions-spacing {\r\n    display: flex;\r\n    justify-content: center;\r\n    /* Align buttons in the center */\r\n    gap: 15px;\r\n    /* Adjust space between buttons */\n}\r\n  \r\n  /* Optional: Adjust individual button margins */\n[dir] .swal-confirm-btn {\r\n    padding: 8px 16px;\n}\n[dir] .swal-cancel-btn {\r\n    padding: 8px 16px;\n}\r\n", ""]);
// Exports
module.exports = exports;
